import React, { Component } from 'react';
import Subscribe from '../../containers/Others/Subscribe';

class Footer extends Component {
  render() {
    return (
      <footer className="main-footer clearfix">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-6 footer-item clearfix">
              <div className="footer-item-content">
                <a href="/" className="footer-logo">
                  <img src="/img/logos/logo-footer-2.png" alt="footer-logo" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="http://www.startupchile.org/" className="startup-logo">
                  <img src="http://www.startupchile.org/wp-content/uploads/2016/10/logo.png" alt="Startup Chile" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.corfo.cl/sites/cpp/home" className="startup-logo">
                  <img src="http://phineal.com/wp-content/uploads/2017/10/CORFO-LOGO-BLANCO-01.png" alt="Corfo Chile" />
                </a>
                <div className="clearfix" />

                <div className="sub-footer">
                  <div className="social-list">
                    <ul className="clearfix">
                      <li className="facebook">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/EscenaMarketplace/">
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li className="instagram">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/escena.digital/">
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                      <li className="linkedin">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/escenadigital/">
                          <i className="fa fa-linkedin" />
                        </a>
                      </li>
                      <li className="twitter">
                        <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/EscenaD">
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
            <div className="col-md-4 col-sm-6 footer-item clearfix">
              <div className="footer-item-content">
                <h2 className="title">Contacto</h2>
                <ul className="contact-info">
                  <li className="clearfix">
                    <i className="fa fa-envelope-o fa-lg" />
                    <label>
                      <a href="mailto:hola@escena.xyz">
                        hello@escena.digital
                      </a>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 footer-item clearfix">
              <div className="footer-item-content">
                <Subscribe />
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js